import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

// components //
import Header from "../../molecules/header/header";
import Footer from "../footer/footer";
import NavMenu from "../../molecules/nav-menu/";
import GlobalContext from "../../../contexts/globalContext";
import PizzaButton from "../../molecules/pizza-button/";
import Headboard from "../headboard/headboard";
import HeadboardSalaPrensa from "../headboard-sala-prensa/headboardSalaPrensa";
import HeadboardSalaPrensa2 from "../headboard-sala-prensa2/headboardSalaPrensa2";
import HeadboardUnete from "../headboard-unete/headboardUnete";
import HeadboardCommunities from "../headboard-communities/headboardCommunities";
import HeadboardForoInterna from "../headboard-foro-interna/headboardForoInterna";
import HeadboardEvents from "../headboard-events/headboardEvents";
import { useStaticQuery, graphql } from "gatsby";

// Hooks //
import useChangeTheme from "../../../shared/hooks/useChangeTheme";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import useLoginGigya from "../../../shared/hooks/useLoginGigya";

// Interfaces //
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";

// Styles //
import "./layout.scss";
import HeadboardMultimedia from "../headerboard-multimedia/headerboardMultimedia";
import HeadboardBibliotecas from "../headboard-bibliotecas/headboardBibliotecas";
import HeadboardMpcVerificacion from "../headboard-mpc-verificacion/headboardMpcVerificacion";
import NavMenuEmpresas from "../../molecules/nav-menu-empresas";
import NavMenuPersonas from "../../molecules/nav-menu-personas/navMenuPersonas";
import HeadboardOffer from "../headboard-offer/headboardOffer";
import { useToggleTheme } from "@comfama/comfama-ui";
import HeadboardRouter from "../headboard-router/headboardRouter";

interface LayoutInterface {
    children: any;
    headboard?: ReferenciaCabecera;
    categoryName?: string;
    contentfulEntryID?: string;
    location?: any;
}

const Layout = (props: LayoutInterface) => {
    const [isDark, changeDarkMode] = useChangeTheme();
    const {setTheme} = useToggleTheme();
    const {isBrowser, localStorage, document } = useBrowserMode();
    const [size, setSize] = useState(0);
    const [isSearcherActive, setSearcherActive] = useState(false);
    const [isMenuActive, setMenuActive] = useState(false);
    const [_superFooter, setSuperFooter] = useState<boolean>(false);
    const [searchWordContent, setSearchWordContent] = useState("");
    const [showModalNewLeader, setShowModalNewLeader] = useState(false);
    const [showModalEditLeader, setShowModalEditLeader] = useState(false);

    const gigyaContext = useLoginGigya();

    useEffect(() => {
        if (isBrowser) {
            const realSize = parseInt(
                localStorage.getItem("font-size") || "100"
            );
            const item = document.querySelector("html") || {
                style: { fontSize: realSize },
            };
            item.style.fontSize = `${realSize}%`;
            setSize(realSize);
        }
    }, []);

    const doSetSize = (_size: number) => {
        localStorage.setItem("font-size", `${_size}`);
        setSize(_size);
    };

    const context = {
        fontSize: { get: size, set: doSetSize },
        superFooter: { get: _superFooter, set: setSuperFooter },
        gigyaContext: { ...gigyaContext },
        searchWordContent,
        setSearchWordContent,
        showModalNewLeader: {get: showModalNewLeader, set: setShowModalNewLeader},
        showModalEditLeader: {get: showModalEditLeader, set: setShowModalEditLeader}
    };

    const data = useStaticQuery(graphql`
        query PIZZA_BUTTON {
            allContentfulMenuCircular(
                filter: { nombre: { eq: "Botón Pizza" } }
            ) {
                nodes {
                    botonesInternos {
                        nombre
                        # icono
                        iconoImagen {
                            file {
                                url
                            }
                        }
                        link
                    }
                    icono {
                        file {
                            url
                        }
                    }
                    iconoCerrar {
                        file {
                            url
                        }
                    }
                }
            }
        }
    `);

    const switchHeadBoard = (headboard: ReferenciaCabecera, superFooter) => {
        console.log("a", headboard)
        switch (headboard.tipoCabecera) {
            case "CabeceraPrincipal":
                return <Headboard {...headboard} />;
            case "CabeceraSalaPrensa":
                return <HeadboardSalaPrensa {...headboard} />;
            case "CabeceraSalaPrensa2":
                return <HeadboardSalaPrensa2 {...headboard} />;
            case "CabeceraUnete":
                return <HeadboardUnete {...headboard} callToAction={() => context.showModalEditLeader.set(true)} />;
            case "CabeceraComunidades":
                return <HeadboardCommunities {...headboard} location={props.location}/>;
            case "CabeceraForo":
                return <HeadboardForoInterna {...headboard} />;
            case "CabeceraMultimedia":
                return <HeadboardMultimedia {...headboard} />;    
            case "CabeceraEvento":
                return <HeadboardEvents {...headboard} />;
            case "CabeceraBibliotecaEmpresas":
                return <HeadboardBibliotecas {...headboard} />;
            case "CabeceraBibliotecaPersonas":
                return <HeadboardBibliotecas {...headboard} />;
            case "CabeceraMpcVerificacion":
                return <HeadboardMpcVerificacion {...headboard} />;
            case "CabeceraInternaOferta":
                return <HeadboardOffer {...headboard} />;
            case "cabeceraEnrutador":
                 return <HeadboardRouter {...headboard} />;
            case "SinCabecera":
                return null;
            default:
                return <Headboard {...headboard} />;
        }
    };

    useEffect(() => {
        if (isDark) return setTheme("dark");
        setTheme("light");
    },[isDark])

    return (
        <GlobalContext.Provider value={context}>
            <Header
                isDark={isDark}
                actionTheme={changeDarkMode}
                isSearcherActive={isSearcherActive}
                isMenuActive={isMenuActive}
                setMenuActive={setMenuActive}
                setSearcherActive={setSearcherActive}
                contentfulEntryID={props.contentfulEntryID}
                location={props.location}
            />
            <>
                {props.headboard &&
                    switchHeadBoard(props.headboard, context.superFooter)}
                <main className={`main-${props.categoryName}`}>
                    {props.children}
                </main>
            </>
            <PizzaButton
                iconOpen={
                    data.allContentfulMenuCircular.nodes[0].icono.file.url
                }
                iconClose={
                    data.allContentfulMenuCircular.nodes[0].iconoCerrar.file.url
                }
                data={data.allContentfulMenuCircular.nodes[0].botonesInternos}
            />
            <Footer />
        </GlobalContext.Provider>
    );
};

export default Layout;